import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from 'src/app/pages/login/login.component';
import { RedirectLoginService } from 'src/app/services/redirect-login/redirect-login.service';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    canActivate: [RedirectLoginService],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OauthRoutingModule { }
